<template>
	<div class="card cardptpr" :onclick="this.url ? 'window.open(\'' + this.url + '\')' : ''">
		<div class="card-header p-3 pb-0 pt-0">
			<H6 v-if="this.title">{{this.title}}</H6>
		</div>
		<div class="card-body p-0" >
			<ul class="list-group" v-for="(item, index) in this.data" :key="index">
				<li :class="'list-group-item border-0 d-flex justify-content-between px-3 py-2 mb-0 ' +(item[valuecol][0] * (comp ? comp : 1) > item[valuecol][1] * (comp ? comp : 1) ? 'animate-green' : (item[valuecol][0] * (comp ? comp : 1) == item[valuecol][1] * (comp ? comp : 1) ? 'animate-yellow' : 'animate-red'))" 
						>
					<div :class="'d-flex align-items-center'">
						<div style="padding-right:10px;">
							<i aria-hidden="true" :class="'fas  ' + (item[valuecol][0] * 1 > item[valuecol][1] * 1 ? 'fa-arrow-circle-up' : (item[valuecol][0] * 1 == item[valuecol][1] * 1 ? 'fa-pause-circle' : 'fa-arrow-circle-down')) + ' ' + (item[valuecol][0] * (comp ? comp : 1) > item[valuecol][1] * (comp ? comp : 1) ? 'status-green' : (item[valuecol][0] * (comp ? comp : 1) == item[valuecol][1] * (comp ? comp : 1) ? 'status-yellow' : 'status-red'))"></i>
						</div>
						<div class="d-flex flex-column">
							<span class="d-flex flex-row justify-content-end text-bold text-sm">{{prefix}} {{item[itemcol][0]}}</span>
							<span class="d-flex flex-row justify-content-end text-sm">{{prefix}} {{item[itemcol][1]}}</span>
						</div>
					</div>
					<div class="d-flex flex-column"> 
						<span class="d-flex flex-row justify-content-end text-bold text-sm">{{curr}} {{(div ? item[valuecol][0] / div : item[valuecol][0]) * 1 | formatNum}} {{unit}}</span>
						<span class="d-flex flex-row justify-content-end text-sm">{{curr}} {{(div ? item[valuecol][1] / div : item[valuecol][1]) * 1 | formatNum}} {{unit}}</span>
					</div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
export default{
	props:["data", "title", "unit", "comp", "itemcol", "valuecol", "iconcol", "url", "prefix", "curr", "div"],
	components:{
	},
    mounted(){
    },
    methods:{
	}
}

</script>
<style>
	.status-red{ color:#c7251c; }
	.status-yellow{ color:#e4c437; }
	.status-green{ color:#4ca437; }
</style>